// extracted by mini-css-extract-plugin
export default {"mainCenter":"contact_mainCenter__TTFSw"};